import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { ContentBookmark } from "scmp-app/components/content/content-bookmark";
import { ContentShareWidget } from "scmp-app/components/content/content-share-widget";

export type StickyDivProps = {
  $isSticky: boolean;
};

export const StickyDiv = styled.div<StickyDivProps>`
  opacity: 0;

  transition: opacity 0.3s ease;

  ${props =>
    props.$isSticky &&
    css`
      opacity: 1;
    `}
`;

export const Container = styled.div`
  padding-inline: 28px 28px;

  color: #ffffff;
  font-weight: 300;
  font-family: ${fontRobotoCondensed};

  background-color: #000000;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  max-inline-size: 1560px;
  margin-block: 0;
  margin-inline: auto;
`;

export const Left = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-inline-start: 104px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: calc(504px + (100% - 504px) / 2);
    padding-inline-start: 0;
  }
`;

export const Title = styled(StickyDiv)`
  display: none;

  padding-inline-start: 14px;

  white-space: nowrap;

  overflow: hidden;

  ${props => props.theme.breakpoints.up("desktop")} {
    display: flex;
  }
`;

export const List = styled.div`
  display: flex;
`;

export const Text = styled.span`
  font-size: 20px;
  line-height: 24px;
`;

export const Tag = styled(Text)`
  margin-inline-end: 11px;

  color: #ffca05;
`;

export const Headline = styled(Text)``;

export const Right = styled(StickyDiv)`
  display: flex;
`;

export type NumberBlockProps = {
  $isActive?: boolean;
};

export const NumberBlock = styled.div<NumberBlockProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 40px;
  block-size: 40px;
  margin-inline-end: 1px;

  font-size: 28px;

  background-color: #333333;

  cursor: pointer;

  ${props =>
    props.$isActive &&
    css`
      color: #333333;

      background-color: #ffffff;
    `}
`;

export const Bookmark = styled.div`
  margin-inline-end: 10px;
  padding-inline-start: 20px;
  border-inline-start: 1px solid #ffffff;
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  inline-size: 18px;
  block-size: 21px;
  padding: 0;

  path {
    fill: #ffffff;
  }
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  display: flex;
  div {
    inline-size: 40px;
    block-size: 21px;
    padding: 0;
  }
  ${props => props.theme.breakpoints.up("tablet")} {
    .copy-link {
      display: none;
    }
    .email {
      display: none;
    }
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    .copy-link {
      display: block;
    }
    .email {
      display: block;
    }
  }
`;
